const API_URL = import.meta.env.VITE_API_URL || 'https://api.superhomes.app';

export async function apiCall(method, path, { token, body, deviceId } = {}) {
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers.Authorization = `Bearer ${token}`;
  else if (deviceId) headers['X-Cart-Device-Id'] = deviceId;
  const res = await fetch(`${API_URL}${path}`, {
    method, headers, body: body ? JSON.stringify(body) : undefined,
  });
  if (!res.ok) {
    const detail = await res.json().catch(() => ({}));
    const err = new Error(`${method} ${path} → ${res.status}`);
    err.status = res.status;
    err.detail = detail;
    throw err;
  }
  return res.json();
}

export { API_URL };
